module.exports = __webpack_public_path__ + "img/Mailchimp_logo.aabe06c1.png";